import { gql } from "@apollo/client";

export const GET_ALL_POOJA_BOOKINGS = gql`
  query getAllPoojaBookings {
    getAllPoojaBookings {
       pooja_booking_id
      service_type
      amount
      status
      additional_information
      pooja_datetime
      temple_id
      seva_type_id
      paymentMode
      paymentReference
      devoteeName
      gothram
      temple_id
      created_at
      phoneNumber
      devoteeAddress
      bookingId
      relationName
      poojaCategory
      specialPoojaName
      createdBy
      userDetails {
      firstName
      lastName
      }
    }
  }
`;

export const GET_ALL_POOJA_BOOKINGS_WITH_PAGINATION = gql`
  query getAllPoojaBookingsWithPagination($input: PaginationInput) {
    getAllPoojaBookingsWithPagination(input: $input) {
      data {
        pooja_booking_id
        service_type
        amount
        status
        additional_information
        pooja_datetime
        temple_id
        seva_type_id
        paymentMode
        paymentReference
        devoteeName
        gothram
        created_at
        phoneNumber
        devoteeAddress
        bookingId
        relationName
        poojaCategory
        specialPoojaName
        createdBy
        userDetails {
          firstName
          lastName
        }
      }
      pagination {
        total
        page
        limit
        totalPages
      }
    }
  }
`;

export const GET_POOJA_BOOKING_BY_ID = gql`
  query getPoojaBookingById($pooja_booking_id: ID!) {
    getPoojaBookingById(pooja_booking_id: $pooja_booking_id) {
      pooja_booking_id
      service_type
      amount
      status
      additional_information
      pooja_datetime
      temple_id
      seva_type_id
      paymentMode
      paymentReference
      devoteeName
      gothram
      phoneNumber
      devoteeAddress
      created_at
      bookingId
      relationName
      poojaCategory
      specialPoojaName
      createdBy
    }
  }
`;

export const CREATE_POOJA_BOOKING = gql`
  mutation createPoojaBooking($input: createPoojaBookingInput) {
    createPoojaBooking(input: $input) {
      pooja_booking_id
      service_type
      amount
      status
      additional_information
      pooja_datetime
      temple_id
      seva_type_id
      paymentMode
      paymentReference
      devoteeName
      gothram
      created_at
      bookingId
      relationName
      devoteeAddress
      phoneNumber
      poojaCategory
      specialPoojaName
      createdBy
    }
  }
`;

export const DELETE_POOJA_BOOKING = gql`
  mutation deletePoojaBooking($pooja_booking_id: ID!) {
    deletePoojaBooking(pooja_booking_id: $pooja_booking_id)
  }
`;

export const UPDATE_POOJA_BOOKING = gql`
  mutation updatePoojaBooking($input: updatePoojaBookingInput) {
    updatePoojaBooking(input: $input) {
      pooja_booking_id
      status
      pooja_datetime
      paymentMode
      paymentReference
      devoteeName
      gothram
      created_at
      bookingId
      relationName
      poojaCategory
      specialPoojaName
      devoteeAddress
      phoneNumber
      createdBy
    }
  }
`;

export const GET_POOJA_BOOKINGS_BY_RECEIPT_ID = gql`
  query getPoojaBookingsByReceiptId($receipt_id: ID!) {
    getPoojaBookingsByReceiptId(receipt_id: $receipt_id) {
      pooja_booking_id
      service_type
      amount
      status
      pooja_datetime
      paymentMode
      paymentReference
      devoteeName
      gothram
      phoneNumber
      devoteeAddress
      created_at
      bookingId
      relationName
      poojaCategory
      specialPoojaName
      createdBy
    }
  }
`;
